<template>
  <input type="checkbox" :indeterminate.prop="indeterminate" :checked="checked" class="checkbox"/>
</template>
<script>

export default {
  name: "indeterminate-checkbox",
  model: {
    prop: "checked"
  },
  props: {
    checked: {
      type: Boolean,
      description: "Whether checkbox is checked"
    },
    indeterminate: {
      type: Boolean,
      description: "Whether checkbox is indeterminate"
    }
  },
  watch: {
    checked(newVal) {
      this.$el.checked = newVal;
    },
    indeterminate(newVal) {
      this.$el.indeterminate = newVal;
    }
  }
};
</script>
<style>
.checkbox {
  --size: 1.125rem;
  block-size: var(--size);
  inline-size: var(--size);
  accent-color: #4E9306;
  margin-right: 0.5rem;
}
</style>
